import { Zap } from 'lucide-react';

interface LogoProps {
  className?: string;
}

export function Logo({ className = '' }: LogoProps) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <span className="flex h-8 w-8 items-center justify-center rounded-xl bg-gradient-to-br from-indigo-500 to-violet-600 shadow-sm">
        <Zap className="h-[18px] w-[18px] text-white" fill="currentColor" strokeWidth={0} />
      </span>
      <span className="text-lg font-bold tracking-tight text-zinc-900 dark:text-white">
        FitScript
      </span>
    </span>
  );
}
